import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-crm-glance',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './crm-glance.html',
  styleUrls: ['./crm-glance.css'],
})
export class CrmGlanceComponent {}
